__turbopack_context__.v({
  "className": "lexend_b67dbf5a-module__YPKfZa__className",
});
